var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 60,
    viewBox: "0 0 66 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8027 10.5991C35.4665 4.36044 41.5518 0.00130435 48.6298 0.00130435C58.1643 0.00130435 65.0311 8.06087 65.8944 17.6661C65.8944 17.6661 66.3604 20.0504 65.3347 24.343C63.9381 30.1891 60.6552 35.383 56.2292 39.347L32.8027 60L9.77084 39.3457C5.34479 35.383 2.06188 30.1878 0.665296 24.3417C-0.360364 20.0491 0.105605 17.6648 0.105605 17.6648C0.968902 8.05957 7.83568 0 17.3702 0C24.4495 0 30.1388 4.36044 32.8027 10.5991Z",
    fill: "#FF6969"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 60
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8027 10.5991C35.4665 4.36044 41.5518 0.00130435 48.6298 0.00130435C58.1643 0.00130435 65.0311 8.06087 65.8944 17.6661C65.8944 17.6661 66.3604 20.0504 65.3347 24.343C63.9381 30.1891 60.6552 35.383 56.2292 39.347L32.8027 60L9.77084 39.3457C5.34479 35.383 2.06188 30.1878 0.665296 24.3417C-0.360364 20.0491 0.105605 17.6648 0.105605 17.6648C0.968902 8.05957 7.83568 0 17.3702 0C24.4495 0 30.1388 4.36044 32.8027 10.5991Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 1,
    r: 34,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19,
    cy: 12,
    r: 39,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.299e88570e6124d3a5a84e4f2314cb5f.svg";
export { ForwardRef as ReactComponent };